import { render, staticRenderFns } from "./DSPPopUp.vue?vue&type=template&id=d8d270ee"
import script from "./DSPPopUp.vue?vue&type=script&lang=js"
export * from "./DSPPopUp.vue?vue&type=script&lang=js"
import style0 from "./DSPPopUp.vue?vue&type=style&index=0&id=d8d270ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports